<script>
import Layout from "../../layouts/main.vue";
import Heading from "../../layouts/heading.vue";
import FormBuilder from "../../layouts/FormBuilder.vue";
import { schema } from "./data";
import api from "../../../api";
import { v4 as uuidv4 } from "uuid";
import Swal from "sweetalert2";

export default {
  props: {
    category: {},
  },
  components: {
    FormBuilder,
    Layout,
    Heading,
  },
  data() {
    return {
      page: schema,
      currentTopicActiveStatus: false,
      location_list: [],
      topics: [],
      topbar: {},
      selectedTab: "",
      selectedItem: {},
      currentCategoryObject: {},
    };
  },
  methods: {
    async getProductNews() {
      if (this.categoryId) {
        let { data } = await api.get("/api/categories/" + this.categoryId);
        this.currentCategoryObject = data;
      }
    },
    async create(data) {
      console.log("create called", data);
      let createObject = {
        uuid: uuidv4(),
        url: "",
        active: true,
        title: data.name,
        picture: "",
        excerpt: "NA",
        description: "",
        deleted: false,
        creationDate: new Date().toISOString(),
        lastModifiedDate: new Date().toISOString(),
        cmsId: this.currentCategoryObject.cmsId,
        additionalProp1: {},
      };

      await api.post(`api/categories/${this.categoryId}/pages`, createObject);
      Swal.fire("Topic Updated!", "Topic Updated Successfully!", "success");

      this.getProductPages();
    },
    deleted() {
      // delete method
    },
    async submit(val) {
      console.log("submit", val);
      // const mainKeys = [
      //   "id",
      //   "uuid",
      //   "creationDate",
      //   "updatedDate",
      //   "fields",
      //   "additionalProp1",
      //   "timestamp",
      //   "cmsId",
      //   "name",
      //   "title",
      // ];
      // Object.keys(val).forEach((key) => {
      //   if (
      //     !mainKeys.includes(key) &&
      //     // eslint-disable-next-line no-prototype-builtins
      //     !val.additionalProp1.hasOwnProperty(key)
      //   ) {
      //     val.additionalProp1[key] = val[key];
      //     delete val[key];
      //   }
      // });
      console.log("after", val);
      await api.patch(`api/pages/${val.id}`, val);
      Swal.fire("Topic Updated!", "Topic Updated Successfully!", "success");
    },
    async activateToggle() {
      this.currentTopicActiveStatus = !this.currentTopicActiveStatus;
      var data = {
        active: this.currentTopicActiveStatus,
      };
      // patch item
      await api.patch(`api/pages/${this.selectedItem.id}`, data);
      Swal.fire("Topic Updated!", "Topic Updated Successfully!", "success");
    },
    selectedItemFn(val) {
      this.selectedItem = val;
      this.currentTopicActiveStatus = val.active;
    },
    selectedTabFn(val) {
      this.selectedTab = val;
      this.topbar = this.page.tabs.filter((tab) => tab.name == val)[0];
    },
    async getProductPages() {
      if (this.categoryId) {
        console.log("=====>", this.categoryId);
        let { data } = await api.get(
          "/api/categories/" + this.categoryId + "/pages"
        );
        console.log("response", data);
        this.topics = data;
        this.page.tabs[0].side_panel.select_a_page.options = data;
        this.topbar = this.page.tabs[0];
      }
    },
  },
  computed: {
    categoryId() {
      return this.$route.params.catId || null;
    },
  },
  watch: {},
  async mounted() {
    this.getProductNews();
    await this.getProductPages();
  },
};
</script>

<template>
  <Layout>
    <Heading
      :page="topbar"
      :activeStatus="currentTopicActiveStatus"
      @activateToggle="activateToggle"
      @created="create"
      @deleted="deleted"
      @form-submitted="submit"
    >
    </Heading>
    <FormBuilder
      :schema="page"
      :category="currentCategoryObject"
      @selected-tab="selectedTabFn"
      @submit="submit"
      @selected-item="selectedItemFn"
    >
    </FormBuilder>
  </Layout>
</template>
